// removed by extract-text-webpack-plugin
module.exports = {"widget":"_3TGEIcY024Fg7fIqYVINm9","title":"_1H7aTZkzkT5qziy9qvhzgL","content":"_238YEGej4Fj5d_vZimUNSX","chart":"_3xOk_kjpPa0_6_zq3D9hg3"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets/BoxMissPickChart/widget.scss
// module id = 1230
// module chunks = 0